import axios from "axios";
import {getItem} from "@/helpers/persistanceStorage";

axios.interceptors.request.use(config =>{
    const token = getItem('authToken')
    const csrf = getItem('csrf')

    config.headers = {
        'X-CSRFToken': csrf,
        'Authorization': token
    }
    return config
})

export  default axios